var _path, _path2, _path3, _path4, _circle, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardRegSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 121,
    viewBox: "0 0 126 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 46H12.5C10.8431 46 9.5 47.3431 9.5 49V97C9.5 98.6569 10.8431 100 12.5 100H84.5C86.1569 100 87.5 98.6569 87.5 97V49C87.5 47.3431 86.1569 46 84.5 46Z",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 88H51.5",
    stroke: "#EE7A00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 88H27.5",
    stroke: "#EE7A00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4978 61.3196H87.4978",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 40,
    r: 37,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.25 32.5L80.9166 50L71.75 41.25",
    stroke: "#EE7A00",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 70C102.069 70 115.5 56.5685 115.5 40C115.5 23.4315 102.069 10 85.5 10C68.9315 10 55.5 23.4315 55.5 40C55.5 56.5685 68.9315 70 85.5 70Z",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardRegSuccess);
export default __webpack_public_path__ + "static/media/card-reg_success.82c76256bf2d4c5c47358eefd70e7ec1.svg";
export { ForwardRef as ReactComponent };